import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from '../ResponsiveImage';
import RichText from '../Prismic/RichText';
import Button from 'wonderbly-components/lib/Button';
import './TextOverBackgroundImage.scss';

const TextOverBackgroundImage = props => (
  <section className="text-over-background">
    <ResponsiveImage images={props.image} className="text-over-background-image" />
    <div className="text-over-background-text">
      <h3 className="text-over-background-title">{props.title}</h3>
      <div className="text-over-background-description">
        <RichText fields={props.description} />
      </div>
      {props.link &&
        props.cta && (
        <Button
          colour="green"
          outlined
          className="text-over-background-button"
          href={props.link}
          onMouseDown={props.onTrackLink({
            action: 'Bottom Partial',
            category: 'Homepage',
          })}>
          {props.cta}
        </Button>
      )}
    </div>
  </section>
);

TextOverBackgroundImage.propTypes = {
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.array.isRequired,
  link: PropTypes.string,
  cta: PropTypes.string,
  onTrackLink: PropTypes.func.isRequired,
};

export default TextOverBackgroundImage;



// WEBPACK FOOTER //
// ./src/client/js/view/components/TextOverBackgroundImage/TextOverBackgroundImage.js